export default __webpack_public_path__ + "static/media/EM0770.34I-21941_-14980_0.1e05b1f2.jpg";